import React from 'react';
import { debounce } from 'lodash';

import { Checkbox, Col, Row } from 'antd';

function CheckListView({
  project,
  
  handleProjectDetailUpdate,
  isReadOnly,
  phaseDetails,
}) {
  // const { ipsProjectDetails } = project || {};

  let handleNoOfAssetsChange = debounce((value) => {
    handleProjectDetailUpdate(value, 'EXPECTED_ASSETS_CNT', 'number');
  }, 1000);

  return (
    <>
      <section className='padding-container'>
        <Row justify='space-around'>
          <Row>
            <Col>
              <Checkbox
                id='ipsassets'
                className=' key-title'
                checked={
                  project && project.ipsAssetsRequired === 'N'
                }
                onChange={(e) => {
                  let value = e.target.checked ? 'N' : 'Y';

                  handleProjectDetailUpdate(
                    value,
                    'IPS_ASSETS_REQUIRED',
                    'string'
                  );
                }}
                disabled={isReadOnly}
                name='selected'
              />
            </Col>
            <Col style={{ marginLeft: '5px' }} className='key-title'>
              Checklist Not Required
            </Col>
          </Row>
          <Row justify='space-between' align='middle'>
            <Col className=' key-title'>No of Assets Expected:</Col>
            <Col style={{ marginLeft: '5px' }}>
              {/* <InputNumber
                  min={0}
                  disabled={
                    isReadOnly ||
                    !(
                      project && project.ipsAssetsRequired === 'Y'
                    )
                  }
                  value={
                    project ? project.expectedAssetsCnt : 0
                  }
                  onChange={handleNoOfAssetsChange}
                /> */}
              {phaseDetails &&
                phaseDetails?.expectedSEAssetsCnt +
                  phaseDetails?.expectedPCEAssetsCnt}
            </Col>
          </Row>
          <Row justify='space-between' align='middle'>
            <Col className='key-title'> Total Assets Received :</Col>
            <Col style={{ marginLeft: '5px' }}>{project.noOfAssets}</Col>
          </Row>
        </Row>
      </section>
    </>
  );
}

export default CheckListView;
